import { render, staticRenderFns } from "./DefaultSpatialFocusEditor.vue?vue&type=template&id=74bf3ecd&scoped=true"
import script from "./DefaultSpatialFocusEditor.vue?vue&type=script&lang=js"
export * from "./DefaultSpatialFocusEditor.vue?vue&type=script&lang=js"
import style0 from "./DefaultSpatialFocusEditor.vue?vue&type=style&index=0&id=74bf3ecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf3ecd",
  null
  
)

export default component.exports